//#region src/domain/i18n/phone-number-length.ts
var PhoneNumberLength = /* @__PURE__ */ function(PhoneNumberLength) {
	PhoneNumberLength[PhoneNumberLength["DO"] = 10] = "DO";
	PhoneNumberLength[PhoneNumberLength["GT"] = 8] = "GT";
	PhoneNumberLength[PhoneNumberLength["HN"] = 8] = "HN";
	PhoneNumberLength[PhoneNumberLength["PE"] = 9] = "PE";
	return PhoneNumberLength;
}({});
//#endregion
export { PhoneNumberLength };

//# sourceMappingURL=phone-number-length.js.map